import { useNavigate } from 'react-router-dom';

import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MyAccessDialog } from '@/features/access/components/MyAccessDialog';

import { useAuth } from './authContext';

const stringToColour = (str: string) => {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, '0');
  }
  return colour;
};

export const AuthStatus = () => {
  const { username, displayName, isAuthenticated, signout } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (
      !confirm('Are you sure you want to log out of your current session ?')
    ) {
      return;
    }
    signout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex justify-end">
      {!isAuthenticated ? (
        <p>You are not logged in.</p>
      ) : (
        <Dialog>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="relative size-10 rounded-full text-base uppercase"
                style={{
                  backgroundColor: stringToColour(username ?? '..'),
                }}
              >
                {username?.slice(0, 2)}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onSelect={handleSubmit}>
                Sign out
              </DropdownMenuItem>
              <DialogTrigger asChild>
                <DropdownMenuItem>My account</DropdownMenuItem>
              </DialogTrigger>
            </DropdownMenuContent>
          </DropdownMenu>
          <DialogContent>
            <MyAccessDialog
              username={username ?? ''}
              displayName={displayName ?? undefined}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};
